import dynamic from 'next/dynamic';
import Image from 'next/image';

import { useGlobal } from '@hultafors/hultaforsgroup/hooks';
import { useMarketPicker } from '@hultafors/shared/context/hooks';

import LogoSvg from '../../svg/logo.svg';
import TogglerMobileSvg from '../../svg/toggler-mobile.svg';
import { Button } from '../button/button';
import { NavigationOpenState } from '../nav/nav';
import { SlideInToggler } from '../slide-in/slide-in';
import LanguageSvg from './distribution-global.svg';
import styles from './navigation-mobile.module.scss';
import {
  NavigationMobileStyled,
  TogglerButton,
} from './navigation-mobile.styled';

const Link = dynamic(() =>
  import('@hultafors/shared/components').then((module) => module.SharedLink),
);

interface NavigationMobileProps {
  defaultOpenSettings: NavigationOpenState;
  setIsOpen(value: NavigationOpenState): void;
  toggleMarketPicker(): void;
  toggleMenu: SlideInToggler;
}

export const NavigationMobile: React.FC<NavigationMobileProps> = ({
  defaultOpenSettings,
  setIsOpen,
  toggleMarketPicker,
  toggleMenu,
}) => {
  const { globalContent: global } = useGlobal();
  const { activeMarket } = useMarketPicker();
  const onClick = () => {
    toggleMenu();
  };
  const datoLogo = global?.navigationLogo?.url;
  function renderLanguageIcon() {
    let iconUrl;

    if (!activeMarket || (!activeMarket?.flag && !activeMarket?.symbol?.url)) {
      return (
        <LanguageSvg
          aria-hidden={true}
          focusable={false}
          height={28}
          width={28}
        />
      );
    }
    if (activeMarket?.flag && !activeMarket?.symbol?.url) {
      iconUrl = `https://flagcdn.com/${activeMarket.flag}.svg`;
    }
    if (activeMarket?.symbol?.url) {
      iconUrl = activeMarket.symbol.url;
    }
    return (
      <img
        alt={activeMarket.name || 'Market Icon'}
        height={24}
        src={iconUrl ?? ''}
        width={24}
      />
    );
  }
  return (
    <NavigationMobileStyled data-test="NavigationMobile">
      <Button
        aria-label={global.menu || 'Menu'}
        className={styles['icon-button']}
        name="menu"
        onClick={onClick}
        withoutStyles
      >
        <TogglerMobileSvg
          aria-hidden={true}
          focusable={false}
          height={24}
          width={24}
        />
      </Button>

      <Link
        aria-label="Hultafors Group"
        className={styles['logo']}
        href="/"
        noHoverEffect
        onClick={() => setIsOpen({ ...defaultOpenSettings })}
      >
        {datoLogo ? (
          <Image
            alt="Hultafors Group"
            fill
            priority
            src={datoLogo}
            style={{ objectFit: 'contain' }}
          />
        ) : (
          <LogoSvg aria-hidden={true} focusable={false} height={14} />
        )}
      </Link>

      <TogglerButton
        aria-label={global?.changeLanguage || ''}
        onClick={toggleMarketPicker}
      >
        {renderLanguageIcon()}
      </TogglerButton>
    </NavigationMobileStyled>
  );
};
